// extracted by mini-css-extract-plugin
export default {"policy-container":"styles_policy-container__RuFGD"};